export enum ClientUserStatus {
  active = "active",
  pending = "invitePending",
  inactive = "inactive",
}
